// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { PageInfoProps, PageInputProps } from '../../../interfaces'
import { AlmacenProp } from '../interfaces'

const gqlQuery = gql`
  query ALMACEN($limit: Int!, $reverse: Boolean, $page: Int!, $query: String) {
    almacenListado(limit: $limit, reverse: $reverse, page: $page, query: $query) {
      pageInfo {
        totalPages
      }
      docs {
        codigoAlmacen
        nombre
        ubicacion
        sucursal {
          codigo
          direccion
        }
        state
        usucre
        createdAt
        usumod
        updatedAt
      }
    }
  }
`

interface AlmacenResponse {
  pageInfo: PageInfoProps
  docs: AlmacenProp[]
}

export const apiAlmacen = async (pageInfo: PageInputProps): Promise<AlmacenResponse> => {
  const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  // Set a single header
  client.setHeader('authorization', `Bearer ${token}`)
  const data: any = await client.request(gqlQuery, { ...pageInfo })
  return data.almacenListado
}
